/* eslint-disable css-modules/no-unused-class */
import { Icon } from 'common-components';
import { FC, Fragment } from 'react';
import { UsersScoreTypes } from './usersScoreTypes';
import styles from './userScore.module.scss';
import Avatar from '../avatar/avatar';
import { useTranslationContext } from '../contexts/translationContext';

const UsersScore: FC<UsersScoreTypes> = (props: UsersScoreTypes) => {
    const {
        alreadyTookUsers,
        coins,
        alreadyTookText,
        myPosition,
        isEmpty,
        userAvatar,
        userNickname,
        totalTookUsers,
        backgroundImage
    } = props;
    const userWidth = alreadyTookUsers.length * 4.5;
    const { translate } = useTranslationContext();

    return (
        <div className={styles['users-score']}>
            {backgroundImage && (
                <div className={styles['background-image-wrapper']}>
                    <img src={backgroundImage} className={styles.image} data-testid="background-image" />
                    <div className={styles['image-overly']}></div>
                </div>
            )}
            {coins && (
                <div className={styles['coins-wrapper']}>
                    <div className={styles['text-wrapper']}>
                        <p className={styles.text}>{myPosition ? translate('RetakeToEarn') : translate('Worth')}</p>
                        <p className={styles['coins-text']}>{coins.toLocaleString()}</p>
                    </div>
                    <Icon name="devCoin" />
                </div>
            )}
            {coins && <hr />}
            {myPosition ? (
                <div className={styles['position-wrapper']}>
                    <div className={styles.text}>{translate('YouAre')}</div>
                    <div className={styles.position}>{`#${myPosition}`}</div>
                </div>
            ) : (
                <div>
                    <div className={styles.text}>{alreadyTookText}</div>
                </div>
            )}
            {!isEmpty ? (
                <div className={styles.users} style={{ width: `${userWidth}rem` }}>
                    {alreadyTookUsers.map((user, index) => (
                        <Fragment key={index.toString()}>
                            <Avatar
                                name={user.nickname}
                                avatarSrc={user.profilePicture}
                                tooltipText={user.points?.toLocaleString()}
                            ></Avatar>
                        </Fragment>
                    ))}
                    {totalTookUsers > alreadyTookUsers.length && (
                        <div className={styles.text}>{`+ ${totalTookUsers - alreadyTookUsers.length}`}</div>
                    )}
                </div>
            ) : (
                <div className={styles['empty-users']}>
                    <Avatar name={userNickname || ''} avatarSrc={userAvatar}></Avatar>
                </div>
            )}
        </div>
    );
};

export default UsersScore;
